// utils/modalInterceptors.ts
import { ModalInterceptor } from '../context/ModalContext';

// 默认拦截器
export const defaultModalInterceptors: ModalInterceptor[] = [
  // 拦截器1: 自动添加确认对话框的危险操作样式
  (config, type) => {
    if (type === 'confirm' && config.title?.toString().includes('删除')) {
      return {
        ...config,
        okButtonProps: {
          ...config.okButtonProps,
          danger: true,
        },
        okText: config.okText || '删除',
      };
    }
    return config;
  },

  // 拦截器2: 统一处理 loading 状态
  (config) => {
    let loading = false;

    const originalOnOk = config.onOk;
    if (originalOnOk) {
      config.onOk = async (e) => {
        if (loading) return;
        loading = true;
        try {
          await originalOnOk(e);
        } finally {
          loading = false;
        }
      };
    }

    return config;
  },

  // 拦截器3: 防止重复提交
  (config) => {
    let isSubmitting = false;

    const originalOnOk = config.onOk;
    if (originalOnOk) {
      config.onOk = async (e) => {
        if (isSubmitting) return;
        isSubmitting = true;

        // 禁用按钮
        const newConfig = {
          ...config,
          okButtonProps: {
            ...config.okButtonProps,
            loading: true,
            disabled: true,
          },
        };

        try {
          await originalOnOk(e);
        } finally {
          isSubmitting = false;
        }

        return newConfig;
      };
    }

    return config;
  },
];
